<template>
  <div :class="classes">
    <div class="buttonGroup" v-if="!inModal">
      <Button
        v-for="(item, index) in buttonGroup"
        :key="index"
        @click="buttonClick(item)"
        v-text="item.name"
      />
    </div>

    <div class="content">
      <!-- 商品／颜色主图 -->
      <Collapse
        v-model="openCollapse"
      >
        <Panel
          name="1"
          title-type="center"
          class="panel-01"
        >
          {{$t('messages.productColorMainImage')}}
          <div
            slot="content"
            class="item-area"
          >
            <!-- 主图 -->
            <div class="pro_img pro_main">
              <div class="left-label">商品主图：</div>
              <div class="imageContent">
                <ul class="clearfix">
                  <li
                    v-for="(item,index) in mainImg"
                    :key="index"
                     v-dragging="{ item: item, list: proImg, group: 'color', key: item }"
                    @mouseout.stop="proImgOut(item)"
                    @mouseover.stop="proImgDrag(item)"
                    @mousedown.stop="proImgOut(item)"
                  >
                    <Poptip
                      v-model="item.flag"
                      placement="right"
                      title
                      trigger="hover"
                      popper-class="el-popover-img"
                      transfer
                    >
                      <el-image
                        style="width: 84px;height: 84px;border: 1px solid var(--s-divider);"
                        fit="cover"
                        :src="item.URL+'?x-oss-process=image/quality,q_80'"
                        :title="item.NAME"
                        :preview-src-list="mainImgAll">
                      </el-image>
                      <div
                        slot="content"
                        :style="{'background-position': 'center','background-repeat':'no-repeat','background-size':'auto 100%',backgroundImage: 'url('+item.URL+'?x-oss-process=image/quality,q_80)',height:'300px',width:'300px',}"
                        :title="item.NAME"
                      />
                    </Poptip>
                  </li>

                  <li
                    v-if="!mainImg.length"
                    @click="proImgChange"
                  >
                    <div class="upload-div">
                      <el-progress
                        v-if="progressImg"
                        type="circle"
                        :percentage="progressImg"
                        :width="60"
                        :status="exception"
                      />
                      <span style="padding: 6px;">无素材</span>
                      <!-- <Icon v-else type="ios-add" /> -->
                    </div>
                    <form
                      role="form"
                      method="POST"
                      enctype="multipart/form-data"
                      style="display: none"
                    >
                      <div>
                        <input
                          :id="'proImg'+objId"
                          type="file"
                          multiple="multiple"
                          style="filter:alpha(opacity=0);opacity:0;width: 0;height: 0;display: none"
                          @change.stop="uploadFileChange($event)"
                        >
                      </div>
                    </form>
                  </li>
                </ul>
                <p class="imageInstruction">
                  <i style="color:red;" class="iconfont iconios-information-circle-outline mg-rt-5 font-size-14"></i>
                  商品主图
                </p>
              </div>
            </div>

            <!-- 视频 -->
            <div class="pro_img pro_video" :style="{'margin-bottom': video ? '12px' : 0}">
              <div class="left-label">商品视频：</div>
              <div class="imageContent">
                <ul>
                  <li
                    v-if="video"
                    style="height: auto; width: auto"
                    @click="previewVideo"
                    @mouseout.stop="proVideoOut"
                    @mouseover.stop="proVideoDrag"
                    @mousedown.stop="proVideoOut"
                  >
                    <i
                      v-show="false"
                      class="iconfont iconios-close-circle"
                      @click.stop="proVideoDelect"
                      @mousedown.stop
                    />
                    <video id="videoDom" :src="video" controls muted autoplay :style="{height:'120px',width:'180px',border:'1px solid var(--s-divider)'}">
                      <source :src="video" type="video/*"/>
                    </video>
                  </li>
                  <li
                    v-if="!video"
                    @click="proVideoAdd"
                  >
                    <div class="upload-div">
                      <el-progress
                        v-if="progress"
                        type="circle"
                        :percentage="progress"
                        :width="60"
                        :status="exception"
                      />
                      <span style="padding: 6px;">无素材</span>
                      <!-- <Icon v-else type="ios-add" /> -->
                    </div>
                    <form
                      role="form"
                      method="POST"
                      enctype="multipart/form-data"
                      style="display: none"
                    >
                      <div>
                        <input
                          :id="'proVideo'+objId"
                          type="file"
                          multiple="multiple"
                          style="filter:alpha(opacity=0);opacity:0;width: 0;height: 0;display: none"
                          @change.stop="uploadFileChange($event, 'video')"
                        >
                      </div>
                    </form>
                  </li>
                </ul>
                <p class="imageInstruction">
                  <i style="color:red;" class="iconfont iconios-information-circle-outline mg-rt-5 font-size-14"></i>
                  建议大小：小于50MB
                </p>
              </div>
            </div>

            <div style="width: 100%;min-height: 0;" data-des="换行"></div>

            <!-- 详情图 -->
            <div class="pro_img pro_detailes">
              <div class="left-label">商品图片：</div>
              <div class="imageContent">
                <ul class="clearfix">
                  <li
                    v-for="(item,index) in proImg"
                    :key="index"
                    v-dragging="{ item: item, list: proImg, group: 'color', key: item }"
                    @mouseout.stop="proImgOut(item)"
                    @mouseover.stop="proImgDrag(item)"
                    @mousedown.stop="proImgOut(item)"
                  >
                    <!-- 删除图片icon -->
                    <i
                      v-show="false"
                      class="iconfont iconios-close-circle"
                      @click.stop="proImgDelect(item,index)"
                      @mousedown.stop
                    />
                    <Poptip
                      v-model="item.flag"
                      placement="right"
                      title
                      trigger="hover"
                      popper-class="el-popover-img"
                      transfer
                    >
                      <el-image
                        style="width: 84px;height: 84px;border: 1px solid var(--s-divider);"
                        fit="cover"
                        :src="item.URL+'?x-oss-process=image/quality,q_80'"
                        :title="item.NAME"
                        :preview-src-list="proImgAll">
                      </el-image>
                      <div
                        slot="content"
                        :style="{'background-position': 'center','background-repeat':'no-repeat','background-size':'auto 100%',backgroundImage: 'url('+item.URL+'?x-oss-process=image/quality,q_80)',height:'300px',width:'300px',}"
                        :title="item.NAME"
                      />
                    </Poptip>
                  </li>

                  <li
                    v-if="!proImg.length"
                    @click="proImgChange"
                  >
                    <div class="upload-div">
                      <el-progress
                        v-if="progressImg"
                        type="circle"
                        :percentage="progressImg"
                        :width="60"
                        :status="exception"
                      />
                      <span style="padding: 6px;">无素材</span>
                      <!-- <Icon v-else type="ios-add" /> -->
                    </div>
                    <form
                      role="form"
                      method="POST"
                      enctype="multipart/form-data"
                      style="display: none"
                    >
                      <div>
                        <input
                          :id="'proImg'+objId"
                          type="file"
                          multiple="multiple"
                          style="filter:alpha(opacity=0);opacity:0;width: 0;height: 0;display: none"
                          @change.stop="uploadFileChange($event)"
                        >
                      </div>
                    </form>
                  </li>
                </ul>
                <p class="imageInstruction">
                  <i style="color:red;" class="iconfont iconios-information-circle-outline mg-rt-5 font-size-14"></i>
                  <!-- 建议尺寸：800*800像素，默认第一张图为主图，您可以拖拽图片调整顺序，最多上传15张 -->
                  您可以拖拽图片调整顺序
                </p>
              </div>
            </div>

            <!-- 颜色 -->
            <div class="pro_color_img" v-if="false">
              <div>{{$t('messages.colorMainImage')}}：</div>
              <div class="imageContent">
                <ul class="clearfix">
                  <li
                    v-for="(item,index) in colorList"
                    :key="index"
                  >
                    <span>{{ item.ECODE+item.ENAME }}</span>
                    <div
                      @mouseout.stop="colImgOut(item)"
                      @mouseover.stop="colImgDrag(item)"
                      @mousedown.stop="colImgOut(item)"
                    >
                      <i
                        v-show="item.flag&&item.URL"
                        class="iconfont iconios-close-circle"
                        @click.stop="colImgDelete(item,index)"
                        @mousedown.stop
                      />

                      <Poptip
                        v-model="item.flag"
                        placement="right"
                        title
                        trigger="hover"
                        transfer
                        popper-class="el-popover-img"
                      >
                        <span
                          v-if="!item.URL"
                          class="upload-span"
                          @click="colImgChange(item,index)"
                        >+ {{$t('tips.addPicture')}}
                          <form
                            role="form"
                            method="POST"
                            enctype="multipart/form-data"
                          >
                            <div>
                              <input
                                :id="'colImg'+objId+index"
                                type="file"
                                style="filter:alpha(opacity=0);opacity:0;width: 0;height: 0;display: none"
                                @change.stop="uploadColorChange(item,index)"
                              >
                            </div>
                          </form>
                        </span>

                        <div
                          :style="{'background-position': 'center','background-repeat':'no-repeat','background-size':'auto 100%',backgroundImage: 'url('+item.URL+'?x-oss-process=image/quality,q_80)',height:'62px',width:'64px'}"
                          :title="item.NAME"
                        />
                        <div
                          v-if="item.URL"
                          slot="content"
                          :style="{'background-position': 'center','background-repeat':'no-repeat','background-size':'auto 100%',backgroundImage: 'url('+item.URL+'?x-oss-process=image/quality,q_80)',height:'300px',width:'300px'}"
                          :title="item.NAME"
                        />
                      </Poptip>
                    </div>
                  </li>
                </ul>
                <p class="imageInstruction">
                  {{$t('messages.suggestImageMaintain')}}
                </p>
              </div>
            </div>
          </div>
        </Panel>
        <Panel name="2" v-show="false">
          商品详情
          <div
            slot="content"
            class="item-area"
          >
            <bclEditor
              v-model="wEditor.item.valuedata"
              :http="wEditor.http"
              :isActives="wEditor.isActives"
              :tabAction="wEditor.tabAction"
              :ref="'editor' + objId"
              @on-value-change="getChangeItem"
            />
          </div>
        </Panel>
      </Collapse>
    </div>
    <Modal
      v-model="dialogShow"
      :title="$t('messages.videoUploadTutorial')"
      :width="1100"
      :height="560"
      :footer-hide="true"
      :closable="true"
    >
      <div class="dialog-scroll">
        <!-- <img
          src="./image/course.jpg"
          width="100%"
        > -->
      </div>
    </Modal>
  </div>
</template>

<script>
  import axios from 'axios';
  // import network, { urlSearchParams } from 'R3';
  // import { custommizedRequestUrl, MODULE_COMPONENT_NAME, INSTANCE_ROUTE_QUERY, classFix } from '../../constants/global';
  // import store from '../../__config__/store.config';
  // import { DispatchEvent } from '../../__utils__/dispatchEvent';
  const custommizedRequestUrl = () => (window.ProjectConfig && window.ProjectConfig.custommizedRequestURL ? window.ProjectConfig.custommizedRequestURL : {});
  const classFix = window.ProjectConfig && window.ProjectConfig.classFix ? window.ProjectConfig.classFix : '';
  const MODULE_COMPONENT_NAME = 'moduleComponentName';
  const INSTANCE_ROUTE_QUERY = 'instanceRouteQuery';
  const store = vm.$store
  const { network, urlSearchParams } = R3

  export default {
    name: 'ProDesc',
    inject: [MODULE_COMPONENT_NAME, INSTANCE_ROUTE_QUERY],
    components: {
      bclEditor: $Bcl.arkWangeditor
    },
    created() {
      const { itemId } = this.$route.params;
      if (itemId !== 'New') {
        this.getData();
      }
    },
    mounted() {
      const { itemId } = this.$route.params;
      this.objId = itemId;
      if (!this._inactive) {
        this.$dragging.$on('dragged', (res) => {
          this.proImg = res.value.list;
          this.saveObj.IMAGE = JSON.stringify(this.proImg);
        });
        window.addEventListener('tabClick', this.tabClick);
      }
    },
    props: {
      itemInfo: {// 当前子表信息
        type: Object,
        default: () => ({})
      },
    },
    watch: {
      '$store.state.omsStore.PS_C_PRO_LOG_DATA': {
        handler(v) {
          this.inModal = Boolean(v)
          if (v) {
            this.version = v
          }
        },
        immediate: true
      }
    },
    data() {
      return {
        inModal: false,
        wEditor: {
          tabAction: false, // 禁用菜单
          isActives: false, // 禁用输入区域
          placeholder: '',
          http: network,
          item: {
            // 富文本的传值
            colid: this.objId,
            valuedata: ''
          }
        },
        progressImg: 0,
        exception: '', //进度条当前状态
        progress: 0, // 进度条
        tabIndex: null,
        buttonGroup: [
          { name: this.$t('buttons.save'), eName: 'save' },
          { name: this.$t('buttons.refresh'), eName: 'refresh' },
          { name: this.$t('buttons.back'), eName: 'back' }
        ],
        saveParams: {},
        dialogShow: false,
        objId: '',
        openCollapse: ['1', '2'],
        video: '',
        videoCover: '',
        videoClearShow: false,
        proImgAll: [],
        mainImg:[],
        mainImgAll: [],
        proImg: [
        // 商品主图
        ],
        colorList: [
        // 颜色主图
        ],

        saveObj: {
        // 保存数据
        },
        uploadImage: 'http://signin.aliyun.com/qiaodan/login.htm'
      };
    },
    computed: {
      classes: () => `${classFix}pro_desc`
    },
    methods: {
      getChangeItem(val) {
        console.log('wEditChange::', val);
        this.wEditor.item.valuedata = val;
      },
      tabClick(tabData) {
        this.tabIndex = tabData.detail.index;
      },
      buttonClick(data) {
        if (data.eName === 'save') {
          this.objectSave();
        } else if (data.eName === 'refresh') {
          this.refresh();
        } else {
          const { tableName, tableId } = this.$route.params;
          const param = {
            tableId,
            tableName,
            back: true,
          };
          store.commit('global/tabOpen', param);
        }
      },
      refresh() {
        this.getData('refresh');
        const { itemId } = this.$route.params;
        const param = {
          table: 'ps_c_pro_desc',
          objid: itemId,
          refcolid: -1,
          tabIndex: this.tabIndex,
          itemInfo: this.itemInfo
        };
        store.dispatch(`${this[MODULE_COMPONENT_NAME]}/getItemObjForChildTableForm`, param);
      },
      // clickCustomize(event) {
      //   // store.commit(`${this[MODULE_COMPONENT_NAME]}/updateModifyData`, { tableName: this.itemInfo.tablename, value: this.saveObj });
      //   if (event.detail.type === 'save') {
      //     this.saveParams = event.detail;
      //     this.objectSave(event.detail);
      //   }
      // },
      getData(type) {
        // 获取数据

        const { itemId } = this.$route.params;

        // 获取主图
        const url = custommizedRequestUrl()['/p/cs/proImage'];
        const loadingName = this.$route.meta.moduleName.replace(/\./g, '-');
        this.$R3loading.show(loadingName);
        const params = new URLSearchParams();
        params.append('psCProId', itemId)
        params.append('flag', Date.now())
        if (this.version) {
          params.append('version', this.version)
        }
        network.post('/api/cs/md/v2/psCSpuMaterial/query', params).then((res) => {
          if (res.data.code === 0) {
            if (res.data.data) {
              this.initData = _.cloneDeep(res.data.data)
              this.proImg = [];
              // 商品主图
              if (res.data.data.mainImage) {
                res.data.data.mainImage.URL = res.data.data.mainImage.MATERIAL_URL || ''
                res.data.data.mainImage.NAME = ''
                res.data.data.mainImage.flag = false
                this.mainImg = [ res.data.data.mainImage ]
                this.mainImgAll = [ res.data.data.mainImage.URL ]
              }
              // 详情图
              if (res.data.data.image) {
                res.data.data.image.forEach(i => {
                  i.URL = i.MATERIAL_URL
                  i.NAME = ''
                })
                this.proImg = res.data.data.image;
                const arr = []
                this.proImg.forEach((item) => {
                  this.$set(item, 'flag', false);
                  arr.push(item.URL)
                });
                this.proImgAll = arr
              }
              // 视频
              if (res.data.data.video) {
                this.video = res.data.data.video.MATERIAL_URL;
              }

              if (res.data.data.DETAILDESC) { // 更新框架表单修改数据
                const values = {};
                values[this.itemInfo.tablename] = { DETAILDESC: res.data.data.DETAILDESC };
                store.commit(`${this[MODULE_COMPONENT_NAME]}/updateModifyData`, {
                  tableName: this.itemInfo.tablename,
                  value: values,
                });
                if (type === 'refresh') {
                  store.commit(`${this[MODULE_COMPONENT_NAME]}/updateChangeData`, {
                    tableName: this.itemInfo.tablename,
                    value: values,
                  });
                }
              }
            }
          }
          return
          // 获取颜色主图
          const params = {
            param: {
              PS_C_PRO_ID: itemId
            }
          };
          const URL = custommizedRequestUrl()['/p/cs/cprospecload'];
          network.get(URL || '/p/cs/cprospecload', {
            params
          }).then((col) => {
            if (col.data.code === 0) {
              const indexTab = null;

              this.colorList = [];
              this.colorList = col.data.data.COLOR;

              if (col.data.data.COLOR.length > 0) {
                col.data.data.COLOR.forEach((item) => {
                  if (res.data.data) {
                    if (!res.data.data.IMAGE_SKU || res.data.data.IMAGE_SKU.length === 0) {
                      // if (this.modify) {
                      //   this.$set(item, 'URL', '');
                      //   this.$set(item, 'flag', false);
                      //   // item.URL = '/static/img/addImg.png'
                      // } else {
                      // this.$set(item, 'URL', 'http://5b0988e595225.cdn.sohucs.com/images/20180118/a0163c6be9d247918669229bed6c7280.png');
                      this.$set(item, 'flag', false);
                      // item.URL = '/static/img/default@2x.png'
                      // }
                    } else {
                      JSON.parse(res.data.data.IMAGE_SKU).forEach((temp) => {
                        if (temp.ID === item.ID) {
                          this.$set(item, 'flag', false);
                          if (temp.URL) {
                            this.$set(item, 'URL', temp.URL);
                          } else {
                            // this.$set(item, 'URL', 'http://5b0988e595225.cdn.sohucs.com/images/20180118/a0163c6be9d247918669229bed6c7280.png');
                          }
                          // item.URL = temp.URL
                        }
                      });
                    }
                  }
                });
              }
            }
          });
        }).finally(() => {
          this.$R3loading.hide(loadingName);
        });
      },
      reaptData(obj) { // 深拷贝
        if (obj instanceof Array) { // array
          const temp = [];
          obj.forEach((item, index) => {
            const temp2 = [];
            if (item instanceof Array) {
              item.forEach((item2, index) => {
                temp2.push(item2);
              });
              temp.push(temp2);
            } else {
              temp.push(item);
            }
          });
          return temp;
        } // obj
        const temp = {};

        for (const item in obj) {
          temp[item] = obj[item];
        }

        return temp;
      },
      objectSave() { // 保存
        console.log(333, this.saveObj);
        this.proImg.forEach(((item) => {
          item.flag = false;
        }));
        if (this.saveObj.IMAGE_SKU) {
          const arr = this.reaptData(JSON.parse(this.saveObj.IMAGE_SKU));

          if (arr.length > 0) {
            arr.forEach((index) => {
              if (index.URL === '') {
                index.URL = null;
              }
              delete index.flag;
            });

            this.saveObj.IMAGE_SKU = JSON.stringify(arr);
          }
        }

        if (this.saveObj.IMAGE) {
          if (JSON.parse(this.saveObj.IMAGE).length > 0) {
            const arr = JSON.parse(this.saveObj.IMAGE);
            if (arr.length > 0) {
              arr.forEach((index) => {
                delete index.flag;
              });
              if (arr.length === 0) {
                this.saveObj.IMAGE = null;
              } else {
                this.saveObj.IMAGE = JSON.stringify(arr);
              }
            }
          } else {
            this.saveObj.IMAGE = null;
          }
        }
        const edit = store.state[`${this[MODULE_COMPONENT_NAME]}`].updateData[this.itemInfo.tablename].modify[this.itemInfo.tablename];
        this.saveObj.DETAILDESC = edit.DETAILDESC;

        if (this.video) this.saveObj.VIDEO = this.video;
        else this.saveObj.VIDEO = '';
        let parames = {
          table: 'PS_C_PRO',
          objid: this.objId,
          param: JSON.stringify(this.proImg)
        };
        let url = '/api/cs/md/v2/psCSpuMaterial/save'
        /* DispatchEvent('beforeSaveAction', {
          detail: {
            type: 'PRO_DESC',
            parames,
            url
          }
        }); */
        network.post(url, urlSearchParams(parames)).then((res) => {
          const { code, message } = res.data
          if (code == 0) {
            const data = {
              title: this.$t('feedback.success'),
              content: `${message}`
            };
            this.$Message.success(data);
            this.saveObj = {};
            this.getData();
          }
        });

        // this.$ajax.dataAjax('/p/cs/objectSave', obj, (res) => {
        //   this.$message({
        //     message: res.message,
        //     type: 'success'
        //   });
        //   this.saveObj = {};
        //   this.getData();
        // });
      },
      proImgDelect(item, index) {
        // 商品主图删除
        this.proImg.splice(index, 1);
        this.saveObj.IMAGE = JSON.stringify(this.proImg);
      },
      proImgChange() {
        return
        const dom = document.getElementById(`proImg${this.objId}`);
        dom.click();
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isGIF = file.type === 'image/gif';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG && !isGIF && !isPNG) {
          const message = this.$t('messages.pictureUploadFormat');
          const data = {
            mask: true,
            title: this.$t('feedback.error'),
            content: `${message}`
          };
          this.$Modal.fcError(data);
          document.querySelector(`#proImg${this.objId}`).value = '';
          document.querySelector(`#colImg${this.objId}`).value = '';
        } else if (!isLt2M) {
          const message = this.$t('messages.pictureUploadSize');
          const data = {
            mask: true,
            title: this.$t('feedback.error'),
            content: `${message}`
          };
          this.$Modal.fcError(data);
          document.querySelector(`#proImg${this.objId}`).value = '';
          document.querySelector(`#colImg${this.objId}`).value = '';
        }
        return (isJPG || isGIF || isPNG) && isLt2M;
      },
      uploadVideo(e) {
        this.exception = ''
        const dom = document.querySelector(`#proVideo${this.objId}`);
        const file = dom.files[0] // 获取选中的文件
        if ([
          'video/mp4',
          'video/ogg',
          'video/flv',
          'video/avi',
          'video/wmv',
          'video/rmvb',
          'video/mov'
        ].indexOf(file.type) === -1
        ) {
          this.$Message.error('请上传正确的视频格式！')
          return false
        }
        if (file.size > 50*1024*1024) {
          this.$Message.error('视频大小不能超过50MB！')
          return false
        }
        const reader = new FileReader()
        reader.onload = e => {
          let data
          if (typeof e.target.result === 'object') {
            data = window.URL.createObjectURL(new Blob([e.target.result]))
          } else {
            data = e.target.result
          }
          this.videosrc = data
          // 获取转换后的地址地址
        }
        // 转化为base64
        reader.readAsDataURL(file)
        const formData = new FormData() // 创建form对象
        const path = `PS_C_PRO/${this.objId}/`;
        formData.append('flag', Date.now());
        formData.append('path', path);
        formData.append('file', file) // 通过append向form对象添加数据const res = await upLoadImage(formData);
        axios({
          url: '/p/cs/upload2',
          method: 'post',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' },
          // 原生获取上传进度的事件
          onUploadProgress: progressEvent => {
            const process = ((progressEvent.loaded / progressEvent.total) * 100) | 0
            this.progress = process
            if (process == 100) {
              this.exception = 'success'
            }
          }
        }).then(res => {
            this.progress = 0
            this.video = res.data.data.Url
            this.saveObj.VIDEO = this.video;
        }).catch(_error => {
          console.log('_error::', _error);
          this.$message({ message: `上传失败`, type: 'error' })
          // 进度条变成失败状态
          this.exception = 'warning'
          // 延时初始化进度条
          setTimeout(() => { this.progress = 0 }, 2000)
        })
      },
      uploadFileChange(e, flag) {
        return
        if (this.progress != 0) {
          this.$Message.error('有一个素材正在上传中，请等待上传完成！')
          return
        }
        if (flag == 'video') {
          this.uploadVideo(e)
          setTimeout(() => {
            document.querySelector(`#proVideo${this.objId}`).value = '';
          }, 200);
          return
        }
        // 主图上传
        this.exception = ''
        const dom = document.querySelector(`#proImg${this.objId}`);
        const list = [...dom.files];
        // const values = dom.files[0];
        if (this.proImg.length + list.length > 15) {
          const message = this.$t('messages.imagesNumberTip',{num:15 - this.proImg.length});
          const data = {
            mask: true,
            title: this.$t('feedback.error'),
            content: `${message}`
          };
          this.$Modal.fcError(data);
          document.querySelector(`#proImg${this.objId}`).value = '';
          return;
        }
        list.forEach((value) => { // 循环调用接口上传
          if (!this.beforeAvatarUpload(value)) {
            return;
          }
          const data = new FormData();
          const path = `PS_C_PRO/${this.objId}/`;

          data.append('file', value);
          data.append('path', path);
          if (value === undefined) {
            return;
          }
          this.progressImg = 1
          axios.post('/p/cs/upload2', data).then((res) => {
            this.uploadProgress(res.data.data.UploadId, (r) => {
              console.log('进度::', r);
              this.progressImg = r
              if (r == 100) {
                this.proImg.push({
                  NAME: res.data.data.Name,
                  URL: res.data.data.Url,
                  flag: false
                });
                this.saveObj.IMAGE = JSON.stringify(this.proImg);
                this.exception = 'success'
                setTimeout(() => {
                  this.progressImg = 0
                }, 1)
              }
            });
          }, false).catch(_error => {
            console.log('_error::', _error);
            this.$message({ message: `上传失败`, type: 'error' })
            // 进度条变成失败状态
            this.exception = 'warning'
            // 延时初始化进度条
            setTimeout(() => { this.progressImg = 0 }, 2000)
          });
          setTimeout(() => {
            document.querySelector(`#proImg${this.objId}`).value = '';
          }, 200);
        });
      },
      uploadProgress(uploadid, cb) {
        // 主图上传进度
        network.post('/p/cs/uploadProgress', urlSearchParams({ uploadId: uploadid, flag: Date.now() })).then((res) => {
          if (res.data.code === 0) {
            if (res.data.data === 100) {
              cb(res.data.data);
            } else {
              setTimeout(() => {
                this.uploadProgress(uploadid, cb(res.data.data));
              }, 50);
            }
          } else {
            document.querySelector(`#proImg${this.objId}`).value = '';
          }
        }).catch(() => {
          document.querySelector(`#proImg${this.objId}`).value = '';
        });
      },
      colImgChange(item, index) {
        const dom = document.getElementById(`colImg${this.objId}${index}`);
        dom.click();
      },
      uploadColorChange(item, index) {
        // 颜色图上传
        const value = document.querySelector(`#colImg${this.objId}${index}`).files[0];
        if (!value || !this.beforeAvatarUpload(value)) {
          return;
        }

        const data = new FormData();
        const path = `PS_C_SKU/${this.objId}/`;
        data.append('file', value);
        data.append('path', path);
        if (value === undefined) {
          return;
        }
        network.post('/p/cs/upload2', data).then((res) => {
          this.uploadProgress(res.data.data.UploadId, () => {
            this.$set(this.colorList[index], 'URL', res.data.data.Url);
            this.saveObj.IMAGE_SKU = JSON.stringify(this.colorList);
          });
        },
        false);

        setTimeout(() => {
          document.querySelector(`#colImg${this.objId}${index}`).value = '';
        }, 200);
      },
      colImgDelete(item, index) {
        // 颜色图的删除
        this.$set(this.colorList[index], 'URL', '');
        this.saveObj.IMAGE_SKU = JSON.stringify(this.colorList);
      },
      proImgDrag(item) {
        // this.proImg[index].flag = true
        this.$set(item, 'flag', true);
      },
      proImgOut(item) {
        // this.proImg[index].flag = false
        this.$set(item, 'flag', false);
      },
      colImgDrag(item) {
        // this.proImg[index].flag = true

        if (item.URL == '') {
        } else {
          this.$set(item, 'flag', true);
        }
      },
      colImgOut(item) {
        // this.proImg[index].flag = false
        this.$set(item, 'flag', false);
      },
      showPicture() {
        this.dialogShow = true;
      },

      proVideoOut() {
        this.videoClearShow = false
      },
      proVideoDrag() {
        this.videoClearShow = true
      },
      proVideoDelect() {
        this.video = ''
      },
      proVideoAdd() {
        return
        const dom = document.getElementById(`proVideo${this.objId}`);
        dom.click();
      },
      previewVideo() {
        const iv = document.getElementById('videoDom')
        iv.oncanplay = function() {
          iv.controls = true   // 控件的显示
          iv.muted = true
          iv.play()
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('tabClick', this.tabClick);
    },
  };
</script>

<style lang="less" scoped>
.item-area {
  display: flex;
  flex-wrap: wrap;
  padding: 12px 0 0;
  .pro_img > div:last-child ul li {
    width: 84px !important;
    height: 84px !important;
  }
}
.pro_desc {
  padding: 8px 0;
  .buttonGroup {
    margin-top: 0;
    height: auto;
    background: #fff;
    padding: 6px 0 0 8px;
    margin-bottom: 6px;
    margin-left: 16px;
    margin-right: 16px;
  }
  .panel-01 /deep/ .ark-collapse-header {
    display: none;
  }
  .pro_main {
    margin-right: 10%;
  }
  .pro_detailes {
    margin-top: 10px;
  }
  .pro_video {
    & > div:last-child ul {
      li {
        padding-bottom: 0 !important;
      }
    }
  }
  .imageInstruction {
    margin-top: -6px !important;
    color: #A9A9A9 !important;
    display: flex;
    align-items: center;
    width: 100%;
  }
  .upload-div {
    height: 64px;
    border: 1px dashed #c0ccda;
    background: #fbfdff;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 28px;
      color: #8c939d;
    }
  }
  .left-label {
    font-size: 0.85rem;
    margin-top: 12px;
  }
}
</style>
